import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { merchantActionTypes } from '../action-types';

export const fetchAuditLogs = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_AUDIT_LOGS_LOADING, payload: true });
		const merchantLogs = await axios.get(`${BASE_URL.MERCHANTS}/auditLogs`);
		const orderLogs = await axios.get(`${BASE_URL.ORDERS}/auditLogs`);
		const identityLogs = await axios.get(`${BASE_URL.IDENTITY}/auditLogs`);
		const paymentLogs = await axios.get(`${BASE_URL.PAYMENTS}/auditLogs`);

		const auditLogs = [];

		if (merchantLogs && merchantLogs.data && Array.isArray(merchantLogs.data.rows)) {
			auditLogs.push(...merchantLogs.data.rows);
		}

		if (orderLogs && orderLogs.data && Array.isArray(orderLogs.data.rows)) {
			auditLogs.push(...orderLogs.data.rows);
		}

		if (identityLogs && identityLogs.data && Array.isArray(identityLogs.data.rows)) {
			auditLogs.push(...identityLogs.data.rows);
		}

		if (paymentLogs && paymentLogs.data && Array.isArray(paymentLogs.data.rows)) {
			auditLogs.push(...paymentLogs.data.rows);
		}

		dispatch({
			type: merchantActionTypes.FETCH_AUDIT_LOGS_LIST,
			// @ts-ignore
			payload: auditLogs.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn))
		});
	} catch (e) {
		dispatch({ type: merchantActionTypes.SET_AUDIT_LOGS_LOADING, payload: false });
		console.log('fetchAuditLogs error', e);
	}
};

export const setAuditLogSTablePagination = (dispatch, value): void => {
	dispatch({
		type: merchantActionTypes.SET_AUDIT_LOGS_TABLE_PAGINATION,
		payload: {
			pageNumber: value.pageIndex,
			pageSize: value.pageSize
		}
	});
};